<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer"  color="secondary" :border="0">
      <v-list-item>
        <v-img height="70px" class="mx-auto" width="170px" src="/images/logo.png" />
      </v-list-item>
      <v-list>
        <v-list-item class="text-primary"  :to="'/pim/'+useUserStore().cekPath()">
          <template v-slot:prepend>
            <v-icon class='custom-icon-red'>mdi-view-dashboard</v-icon>
          </template>
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item>
      </v-list>

      <v-list>
        <v-list-subheader class="text-info">Pelatihan</v-list-subheader>

        <v-list-item v-for="[icon, link, text] in links" :key="icon"  :to="'/pim/'+useUserStore().cekPath()+'/'+link" class="text-primary">
          <template v-slot:prepend>
            <v-icon class='custom-icon-red'>{{ icon }}</v-icon>
          </template>

          <v-list-item-title>{{ text }}</v-list-item-title>
        </v-list-item>
      </v-list>

      <v-list class="mt-0" color="text-primary">
        <v-list-subheader class="text-info">Master Data</v-list-subheader>
        <v-list-group value="Master Data">
          <template v-slot:activator="{ props }">
            <v-list-item v-bind="props"  title="Master Data" class="text-primary">
              <template v-slot:prepend>
              <v-icon class='custom-icon-red'>mdi-database</v-icon>
            </template>
            </v-list-item>
          </template>

          <v-list-item v-for="[icon, link, text] in links2" :key="icon" :to="'/pim/'+useUserStore().cekPath()+'/'+link"  class="text-primary">
            <template v-slot:prepend>
              <v-icon class='custom-icon-red'>mdi-circle-outline</v-icon>
            </template>

            <v-list-item-title>{{ text }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-list class="mt-0" color="text-primary" v-show="CekAdmin()">
        <v-list-subheader class="text-info">Master Data Administrator</v-list-subheader>
        <v-list-group value="Master Data">
          <template v-slot:activator="{ props }">
            <v-list-item v-bind="props"  title="Master Data" class="text-primary">
              <template v-slot:prepend>
              <v-icon class='custom-icon-red'>mdi-database</v-icon>
            </template>
            </v-list-item>
          </template>

          <v-list-item v-for="[icon, link, text] in links3" :key="icon" :to="'/pim/'+useUserStore().cekPath()+'/'+link " class="text-primary">
            <template v-slot:prepend>
              <v-icon class='custom-icon-red'>mdi-circle-outline</v-icon>
            </template>

            <v-list-item-title>{{ text }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-list class="mt-0" color="text-primary" v-show="CekAdmin()">
        <v-list-subheader class="text-info">Referensi</v-list-subheader>
        <v-list-group value="Master Data">
          <template v-slot:activator="{ props }">
            <v-list-item v-bind="props"  title="Master Data" class="text-primary">
              <template v-slot:prepend>
              <v-icon class='custom-icon-red'>mdi-database</v-icon>
            </template>
            </v-list-item>
          </template>

          <v-list-item v-for="[icon, link, text] in links4" :key="icon" :to="'/pim/'+useUserStore().cekPath()+'/'+link"  class="text-primary">
            <template v-slot:prepend>
              <v-icon class='custom-icon-red'>mdi-circle-outline</v-icon>
            </template>

            <v-list-item-title>{{ text }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn block color="error" @click="Logout()">
            Keluar <v-icon>mdi-logout</v-icon></v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar color="secondary" elevation="0">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title class="text-info">Selamat Datang di LMS PIM LAN</v-toolbar-title>
      <v-spacer></v-spacer>

       <NotifIcon/>

      <UserProfile />
    </v-app-bar>
    <v-main>
      <v-container class="pt-0" style="min-height: calc(var(--vh, 1vh) * 100)">
        <Breadcrums />
        <NuxtPage  />
      </v-container>

    </v-main>
    
  <FooterRole/>
  </v-app>
</template>

<script>

export default {
  data: () => ({
    cards: ["Today", "Yesterday"],
    drawer: null,
    links: [
      [
        "mdi-human-male-board",
        "Pelatihan",
        "Data Pelatihan",
      ],
      ["mdi-walk", "pelatihan/pelatihanberjalan", "Pelatihan Berjalan"],
      ["mdi-check-all", "pelatihan/pelatihanselesai", "Pelatihan Selesai"],
    ],
    links2: [
      ["mdi-account", "dataPengajar", "Data Pengajar"],
      ["mdi-account", "DataPembimbing", "Data Pembimbing"],
      ["mdi-account", "DataPenguji", "Data Penguji"],
      ["mdi-account", "DataMentor", "Data Mentor"],
      ["mdi-account", "DataPeserta", "Data Peserta"],
    ],
    links3: [
      ["mdi-account", "Administrator/DataPIC", "Data PIC"],
      ["mdi-account", "Administrator/", "Data Admin"],
    ],
    links4: [
      ["mdi-account", "Referensi/Materi", "Materi"],
      ["mdi-account", "Referensi/JadwalPenting", "Jadwal Penting"],
      ["mdi-account", "Referensi/PolicyPaper", "Step Policy Paper"],
      ["mdi-account", "Referensi/ProyekPerubahan", "Step Proyek Perubahan"],
      ["mdi-account", "Referensi/StudiLapangan", "Step Studi Lapangan"],
      ["mdi-account", "Referensi/VisitasiKepemimpinan", "Step Visitasi Kepemimpinan"],
      ["mdi-account", "Referensi/VisitasiAgenda", "Step Visitasi Agenda"],
      ["mdi-account", "Referensi/BobotPenilaian", "Bobot Penilaian"],
      ["mdi-account", "Referensi/PertanyaanUjian", "Pertanyaan Ujian"],
      ["mdi-account", "Referensi/BukuManual", "Buku Manual"],
    ],
  }),
  methods: {
   
    CekAdmin() {
       return useUserStore().CekIsAdmin();
    },
    Logout() {
      const userStore = useUserStore();
      const delay = 700;
      userStore.$patch({
        snackStatus: "green",
        snackbar: true,
        messageSnack: "Logout Berhasil",
        loggedIn: false,
      });
      setTimeout(() => {
        userStore.$reset();
        navigateTo({ path: "/login" });
      }, delay);
    },
  },
};
</script>

<style>
.v-navigation-drawer {
  overflow-y: auto;
  scroll-behavior: smooth;
}

.v-list-group {
  --prepend-width: -15px;
}

.custom-color {
  background-color: #ff0000;
  color: #ffffff;
}

.custom-item:hover {
  background-color: #00ff00;
  color: #000000;
}

.v-list-item-title {
  font-size: 15px;
}
</style>
